import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Filter } from "sushiweb/Icons";
import './core.scss';

class StateFilterComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        const {filterId} = this.props;
        return (
            <React.Fragment>
              <div className="order-filter-wrapper">
    
                    <div className="inline-list flex align-baseline">
                      <Filter className="inline-block light-text fs-10 icon-small"/>
                      <div className="flex order-filter-wrapper_inner white-space ">
                      <div className={filterId === 4 ? "btn btn-filter btn-active-filter" : "btn btn-filter"} onClick={(e, val) => this.props.handleFilterChange(e, 4)}>
                        Pending
                        {
                          filterId === 4
                          && <FontAwesomeIcon icon="times" className="btn-icon" onClick={(e) => this.props.clearFilter(e)}/>
                        }
                      </div>
                      <div className={filterId === 6 ? "btn btn-filter btn-active-filter" : "btn btn-filter"} onClick={(e, val) => this.props.handleFilterChange(e, 6)}>
                        Re-Attempt
                        {
                          filterId === 6
                          && <FontAwesomeIcon icon="times" className="btn-icon" onClick={(e) => this.props.clearFilter(e)}/>
                        }
                      </div>
                      <div className={filterId == 5 ? "btn btn-filter btn-active-filter" : "btn btn-filter"} onClick={(e, val) => this.props.handleFilterChange(e, 5, true)}>
                        Completed
                        {
                          filterId === 5
                          && <FontAwesomeIcon icon="times" className="btn-icon" onClick={(e) => this.props.clearFilter(e)}/>
                        }
                      </div>
                      </div>
                    </div>
        
            </div>
          </React.Fragment>

        )
    }
}

export default StateFilterComponent;
